"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OutlinedInputWithLabel = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _colorManipulator = require("@material-ui/core/styles/colorManipulator");

var _icons = require("../../icons");

var _formatValue = require("../../utils/formatValue");

var _reverseFormatValue = require("../../utils/reverseFormatValue");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    labelBox: {
      display: 'flex',
      alignItems: 'center',
      margin: 0,
      marginBottom: '16px'
    },
    label: {
      display: 'inline-block',
      fontSize: '1rem',
      color: 'rgba(0, 0, 0, 0.8)'
    },
    infoIconWrapper: {
      display: 'inline-block'
    },
    adornment: {
      fontSize: '1rem',
      color: 'rgba(0, 0, 0, 0.47)'
    },
    inputRoot: {
      backgroundColor: '#fff',
      padding: '10px 12px',
      borderRadius: '8px',
      border: "1px solid #838C83",
      fontSize: '1rem',
      '&:hover': {
        border: '1px solid #545F54'
      }
    },
    inputInput: {
      padding: 0
    },
    inputFocused: {
      border: "1px solid ".concat(theme.palette.primary.main)
    },
    inputDisabled: {
      borderColor: '#B7BFC0',
      backgroundColor: '#F6F7F5',
      color: (0, _colorManipulator.fade)(theme.palette.common.black, 0.8),
      '&:hover': {
        borderColor: '#B7BFC0'
      }
    },
    inputError: {
      border: '1px solid #BC0000'
    },
    errorMessage: {
      paddingTop: '8px',
      paddingLeft: '12px',
      color: '#BC0000',
      fontSize: '12px',
      lineHeight: '16px'
    },
    tooltip: {
      background: theme.palette.common.white,
      border: "1px solid ".concat(theme.palette.primary.main),
      borderRadius: '8px',
      color: theme.palette.common.black
    },
    arrow: {
      color: theme.palette.primary.main
    }
  };
});

var OutlinedInputWithLabel = function OutlinedInputWithLabel(_ref) {
  var value = _ref.value,
      label = _ref.label,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      handleChange = _ref.handleChange,
      disabled = _ref.disabled,
      adornment = _ref.adornment,
      placeholder = _ref.placeholder,
      tooltip = _ref.tooltip,
      error = _ref.error,
      errorMessage = _ref.errorMessage,
      formatInput = _ref.formatInput,
      restProps = _objectWithoutProperties(_ref, ["value", "label", "type", "handleChange", "disabled", "adornment", "placeholder", "tooltip", "error", "errorMessage", "formatInput"]);

  var classes = useStyles();

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var handleClose = function handleClose() {
    setOpen(false);
  };

  var handleOpen = function handleOpen() {
    setOpen(true);
  };

  var formatedValue = (0, _react.useMemo)(function () {
    if (type === 'text' && formatInput) {
      return (0, _formatValue.formatValue)(value);
    }

    return value;
  }, [value, type]);
  var handleFormatChangedValue = (0, _react.useCallback)(function (event) {
    if (handleChange) {
      if (type === 'text' && formatInput) {
        var _value = event.target.value;
        var reversedFormatedValue = (0, _reverseFormatValue.reverseFormatValue)(_value);

        if (reversedFormatedValue) {
          event.target.value = "".concat(reversedFormatedValue);
        }
      }

      handleChange(event);
    }
  }, [handleChange, type]);
  return /*#__PURE__*/_react["default"].createElement(_core.Box, restProps, label && /*#__PURE__*/_react["default"].createElement(_core.Box, {
    m: 1,
    className: classes.labelBox
  }, /*#__PURE__*/_react["default"].createElement(_core.InputLabel, {
    className: classes.label,
    id: "select-label-".concat(label)
  }, label), !!tooltip && /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
    classes: {
      tooltip: classes.tooltip,
      arrow: classes.arrow
    },
    placement: "right",
    arrow: true,
    open: open,
    onClose: handleClose,
    onOpen: handleOpen,
    title: tooltip,
    disableFocusListener: true
  }, /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: classes.infoIconWrapper,
    pl: 1,
    onClick: handleOpen
  }, /*#__PURE__*/_react["default"].createElement(_icons.Faq, {
    fontSize: "small"
  })))), /*#__PURE__*/_react["default"].createElement(_core.FormControl, {
    variant: "outlined",
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_core.InputBase, {
    value: formatedValue,
    onChange: handleFormatChangedValue,
    classes: {
      root: classes.inputRoot,
      input: classes.inputInput,
      disabled: classes.inputDisabled,
      focused: classes.inputFocused,
      error: classes.inputError
    },
    type: type,
    endAdornment: adornment && /*#__PURE__*/_react["default"].createElement(_core.InputAdornment, {
      position: "end",
      className: classes.adornment,
      disableTypography: true,
      disablePointerEvents: true
    }, adornment),
    disabled: disabled,
    fullWidth: true,
    placeholder: placeholder,
    error: error
  })), error && errorMessage && /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    className: classes.errorMessage
  }, errorMessage));
};

exports.OutlinedInputWithLabel = OutlinedInputWithLabel;